import { WIDGET_METRIC_GROUPS } from "@services/math/math.const";

interface ChartDataPoint {
  date: string;
  [key: string]: number | string;
}

export function generateDateRangeArray(
  startDate: string | Date,
  endDate: string | Date,
) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const dates = [];

  const current = new Date(start);

  while (current <= end) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  return dates;
}

export type SalesChecks = {
  [key: string]: boolean;
};

const initialChecks: SalesChecks = {
  totalSales: true,
  adSales: true,
  adSpend: true,
  adImpressions: true,
  adCtr: true,
  adCvr: true,
  tacos: true,
  netProfit: true,
};

export const getInitialChecks = (groups: string[] | "all"): SalesChecks => {
  if (Array.isArray(groups) && groups.length === 1) {
    const keys = WIDGET_METRIC_GROUPS.filter(
      (group) => group.title === groups[0],
    )
      .map((metricGroup) => metricGroup.keys)
      .flat()
      .slice(0, 7);

    console.log("keys", keys);

    const initialChecks: SalesChecks = {};

    keys.forEach((key) => {
      initialChecks[key] = true;
    });
    return initialChecks;
  }
  return initialChecks;
};

export const initialChecksBrand: SalesChecks = {
  totalSales: true,
  adSales: false,
  adSpend: false,
  adImpressions: false,
  adCtr: false,
  adCvr: false,
};

export const initialChecksMarket: SalesChecks = {
  totalSales: true,
  adSales: false,
  adSpend: false,
  adImpressions: false,
  adCtr: false,
  adCvr: false,
};

export function modifyTooltipPayload(payload) {
  if (!payload) return payload;

  const filteredPayload = payload.filter(
    (item) => !String(item?.dataKey ?? "").endsWith("_forecast"),
  );

  return filteredPayload.map((item) => {
    if (!item) return item;
    const newDataKey =
      typeof item.dataKey === "string"
        ? item.dataKey.replace(/_(main|forecast)$/, "")
        : item.dataKey;
    const newName =
      typeof item.name === "string"
        ? item.name.replace(/_(main|forecast)$/, "")
        : item.name;
    return {
      ...item,
      dataKey: newDataKey,
      name: newName,
    };
  });
}

export function mergeMainWithCompare(
  main: ChartDataPoint[],
  compare: ChartDataPoint[],
): ChartDataPoint[] {
  return [...main, ...compare];
}
